import { Injectable, signal } from '@angular/core';

import { SubDivision } from './sub-division.model';

@Injectable({
  providedIn: 'root',
})
export class SubDivisionService {
  readonly subDivision = signal('' as SubDivision);

  setSubDivision(subDivision: SubDivision): void {
    if (subDivision) {
      this.subDivision.set(subDivision);
    }
  }
}
